// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.footer-links:hover {\n  -webkit-text-decoration: revert !important;\n          text-decoration: revert !important;\n}\n", ""]);
// Exports
module.exports = exports;
